import React from 'react';
import { Link } from 'react-router-dom';

const StatsCards = ({ dashboardData, hasPermission, user }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
      {/* User Overview */}
      {hasPermission('dashboard', 'user_overview', 'view') && (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          <div className="p-3 border-b border-gray-200 bg-gray-50">
            <h4 className="text-sm font-semibold text-gray-900 flex items-center">
              <i className="bi bi-bar-chart-fill mr-2" style={{ color: '#009ef7' }}></i>
              User Overview
            </h4>
          </div>
          <div className="p-0">
            <ul className="space-y-1  p-4 ">
              <li className="flex justify-between w-full mb-2">
                <div className="flex items-center  justify-between  ">
                  <span className="w-2.5 h-2.5 rounded-full bg-yellow-500 mr-3"></span>
                  <Link to="/view-users" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Users</Link>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.totalUsers || 0}</span>
              </li>
              <li className="flex justify-between items-left mb-2">
                <div className="flex items-center">
                  <span className="w-2.5 h-2.5 rounded-full bg-green-500 mr-3"></span>
                  <span className="text-gray-400 text-sm">Total Vendor</span>
                </div>
                <span className="text-gray-900 text-sm">
                  {(dashboardData?.unverifiedVendors || 0) + (dashboardData?.verifiedVendors || 0)}
                </span>
              </li>
              <li className="flex justify-between items-center mb-2">
                <div className="flex items-center">
                  <span className="w-2.5 h-2.5 rounded-full bg-green-500 mr-3"></span>
                  <Link to="/view-vendors" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Verified Vendors</Link>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.verifiedVendors || 0}</span>
              </li>
              <li className="flex justify-between items-center mb-2">
                <div className="flex items-center">
                  <span className="w-2.5 h-2.5 rounded-full bg-green-500 mr-3"></span>
                  <Link to="/view-vendors" className="text-gray-400 text-sm hover:text-gray-900 no-underline">UnVerified Vendors</Link>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.unverifiedVendors || 0}</span>
              </li>
            </ul>
          </div>
        </div>
      )}

      {/* Platform Overview */}
      {hasPermission('dashboard', 'platform_overview', 'view') && (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          <div className="p-3 border-b border-gray-200 bg-gray-50">
            <h4 className="text-sm font-semibold text-gray-900 flex items-center">
              <i className="bi bi-bar-chart-fill mr-2" style={{ color: '#009ef7' }}></i>
              Platform Overview
            </h4>
          </div>
          <div className="p-0">
            <ul className="space-y-1 p-4">
              <li className="flex justify-between w-full mb-2">
                <div className="flex items-center justify-between">
                  <span className="w-2.5 h-2.5 rounded-full bg-red-500 mr-3"></span>
                  <Link to="/travel-post" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Travel Leads</Link>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.originalPost || 0}</span>
              </li>
              <li className="flex justify-between items-left mb-2">
                <div className="flex items-center">
                  <span className="w-2.5 h-2.5 rounded-full bg-cyan-500 mr-3"></span>
                  <span className="text-gray-400 text-sm">Offers Submitted</span>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.totalOffer || 0}</span>
              </li>
              <li className="flex justify-between items-center mb-2">
                <div className="flex items-center">
                  <span className="w-2.5 h-2.5 rounded-full bg-cyan-500 mr-3"></span>
                  <Link to="/unlocked-list" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Unlocked</Link>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.buyLeadCount || 0}</span>
              </li>
              <li className="flex justify-between items-center mb-2">
                <div className="flex items-center">
                  <span className="w-2.5 h-2.5 rounded-full bg-cyan-500 mr-3"></span>
                  <Link to="/replacement-list" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Replacement</Link>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.replacementCount || 0}</span>
              </li>
              <li className="flex justify-between items-center mb-2">
                <div className="flex items-center">
                  <span className="w-2.5 h-2.5 rounded-full bg-cyan-500 mr-3"></span>
                  <Link to="/unlocked-list" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Today Unlock Amount</Link>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.totalDebitAmount || 0}</span>
              </li>
            </ul>
          </div>
        </div>
      )}

      {/* Orders Overview */}
      {hasPermission('dashboard', 'order_overview', 'view') && (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          <div className="p-3 border-b border-gray-200 bg-gray-50">
            <h4 className=" text-sm font-semibold text-gray-900 flex items-center">
              <i className="bi bi-cart-check-fill mr-2" style={{ color: '#009ef7' }}></i>
              Orders Overview
            </h4>
          </div>
          <div className="p-0">
            <ul className="space-y-1 p-4">
              <li className="flex justify-between w-full mb-2">
                <div className="flex items-center justify-between">
                  <span className="w-2.5 h-2.5 rounded-full bg-green-500 mr-3"></span>
                  <Link to="/order-list" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Completed</Link>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.completedOrders || 0}</span>
              </li>
              <li className="flex justify-between items-left mb-2">
                <div className="flex items-center">
                  <span className="w-2.5 h-2.5 rounded-full bg-yellow-500 mr-3"></span>
                  <Link to="/order-list" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Pending</Link>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.pendingOrders || 0}</span>
              </li>
              <li className="flex justify-between items-center mb-2">
                <div className="flex items-center">
                  <span className="w-2.5 h-2.5 rounded-full bg-red-500 mr-3"></span>
                  <Link to="/order-list" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Failed</Link>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.failedOrders || 0}</span>
              </li>
              <li className="flex justify-between items-center mb-2">
                <div className="flex items-center">
                  <span className="w-2.5 h-2.5 rounded-full mr-3" style={{ backgroundColor: '#009ef7' }}></span>
                  <Link to="/order-list" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Total Orders</Link>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.totalOrders || 0}</span>
              </li>
              <li className="flex justify-between items-center mb-2">
                <div className="flex items-center">
                  <span className="w-2.5 h-2.5 rounded-full bg-cyan-500 mr-3"></span>
                  <span className="text-gray-400 text-sm">Total Revenue</span>
                </div>
                <span className="text-gray-900 text-sm">₹{dashboardData?.totalRevenue || 0}</span>
              </li>
            </ul>
          </div>
        </div>
      )}

      {/* Feedback Overview */}
      {hasPermission('dashboard', 'feedback_overview', 'view') && (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          <div className="p-3 border-b border-gray-200 bg-gray-50">
            <h4 className="text-sm font-semibold text-gray-900 flex items-center">
              <i className="bi bi-chat-square-text-fill text-red-500 mr-2"></i>
              Feedback
            </h4>
          </div>
          <div className="p-0">
            <ul className="space-y-1 p-4">
              <li className="flex justify-between w-full mb-2">
                <div className="flex items-center justify-between">
                  <span className="w-2.5 h-2.5 rounded-full bg-red-500 mr-3"></span>
                  <Link to="/bank-proof" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Bank Deposit Requests</Link>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.bankDepositRequest || 0}</span>
              </li>
              <li className="flex justify-between items-left mb-2">
                <div className="flex items-center">
                  <span className="w-2.5 h-2.5 rounded-full bg-red-500 mr-3"></span>
                  <Link to="/view-contactus" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Contact Requests</Link>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.contactUs || 0}</span>
              </li>
              <li className="flex justify-between items-center mb-2">
                <div className="flex items-center">
                  <span className="w-2.5 h-2.5 rounded-full mr-3" style={{ backgroundColor: '#009ef7' }}></span>
                  <Link to="/view-corporate-inquiries" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Corporate Tours</Link>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.corporateInquiries || dashboardData?.corporateInquiryCount || 0}</span>
              </li>
              <li className="flex justify-between items-center mb-2">
                <div className="flex items-center">
                  <span className="w-2.5 h-2.5 rounded-full mr-3" style={{ backgroundColor: '#009ef7' }}></span>
                  <Link to="/reports" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Reports</Link>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.reports || 0}</span>
              </li>
              <li className="flex justify-between items-center mb-2">
                <div className="flex items-center">
                  <span className="w-2.5 h-2.5 rounded-full bg-red-500 mr-3"></span>
                  <Link to="/view-suggestions" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Suggestions</Link>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.suggestions || 0}</span>
              </li>
              <li className="flex justify-between items-center mb-2">
                <div className="flex items-center">
                  <span className="w-2.5 h-2.5 rounded-full mr-3" style={{ backgroundColor: '#009ef7' }}></span>
                  <Link to="/view-itsupport" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Support Tickets</Link>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.tickets || 0}</span>
              </li>
              <li className="flex justify-between items-center mb-2">
                <div className="flex items-center">
                  <span className="w-2.5 h-2.5 rounded-full bg-red-500 mr-3"></span>
                  <Link to="/view-leads" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Callbacks</Link>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.callback || 0}</span>
              </li>
              <li className="flex justify-between items-center mb-2">
                <div className="flex items-center">
                  <span className="w-2.5 h-2.5 rounded-full bg-red-500 mr-3"></span>
                  <Link to="/testimonial" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Testimonial</Link>
                </div>
                <span className="text-gray-900 text-sm">{dashboardData?.testimonialCount || 0}</span>
              </li>
            </ul>
          </div>
        </div>
      )}

      {/* Travel Services */}
      {(user?.role !== 'staff' && !user?.services?.includes('caller') || hasPermission('dashboard', 'travel_services', 'view')) && (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          <div className="p-3 border-b border-gray-200 bg-gray-50">
            <h4 className=" text-sm font-semibold text-gray-900 flex items-center">
              <i className="bi bi-globe2 text-green-500 mr-2"></i>
              Travel Services
            </h4>
          </div>
          <div className="p-0">
            <ul className="space-y-1 p-4">
              {(user?.role === 'admin' || user?.services?.includes('packages')) && (
                <li className="flex justify-between w-full mb-2">
                  <div className="flex items-center justify-between">
                    <span className="w-2.5 h-2.5 rounded-full bg-red-500 mr-3"></span>
                    <Link to="/view-packages" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Tour Packages</Link>
                  </div>
                  <span className="text-gray-900 text-sm">{dashboardData?.totalPackages || 0}</span>
                </li>
              )}
              {(user?.role === 'admin' || user?.services?.includes('hotels')) && (
                <li className="flex justify-between items-left mb-2">
                  <div className="flex items-center">
                    <span className="w-2.5 h-2.5 rounded-full mr-3" style={{ backgroundColor: '#009ef7' }}></span>
                    <Link to="/hotel" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Hotels</Link>
                  </div>
                  <span className="text-gray-900 text-sm">{dashboardData?.totalHotels || 0}</span>
                </li>
              )}
              {(user?.role === 'admin' || user?.services?.includes('vehicles')) && (
                <li className="flex justify-between items-center mb-2">
                  <div className="flex items-center">
                    <span className="w-2.5 h-2.5 rounded-full bg-green-500 mr-3"></span>
                    <Link to="/view-vehicles" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Vehicles</Link>
                  </div>
                  <span className="text-gray-900 text-sm">{dashboardData?.totalVehicles || 0}</span>
                </li>
              )}
              {user?.role === 'admin' && (
                <>
                <li className="flex justify-between items-center mb-2">
                  <div className="flex items-center">
                    <span className="w-2.5 h-2.5 rounded-full bg-cyan-500 mr-3"></span>
                    <Link to="/view-itsupport" className="text-gray-400 text-sm hover:text-gray-900 no-underline">IT Support</Link>
                  </div>
                  <span className="text-gray-900 text-sm">{dashboardData?.itSupport || 0}</span>
                </li>
                <li className="flex justify-between items-center mb-2">
                  <div className="flex items-center">
                    <span className="w-2.5 h-2.5 rounded-full bg-cyan-500 mr-3"></span>
                    <Link to="#" className="text-gray-400 text-sm hover:text-gray-900 no-underline">UnPublic Locations</Link>
                  </div>
                  <span className="text-gray-900 text-sm">{dashboardData?.totalUnpublicLocations || 0}</span>
                </li>
                <li className="flex justify-between items-center mb-2">
                  <div className="flex items-center">
                    <span className="w-2.5 h-2.5 rounded-full bg-cyan-500 mr-3"></span>
                    <Link to="#" className="text-gray-400 text-sm hover:text-gray-900 no-underline">UserForum</Link>
                  </div>
                  <span className="text-gray-900 text-sm">{dashboardData?.totalUserForum || 0}</span>
                </li>
                <li className="flex justify-between items-center mb-2">
                  <div className="flex items-center">
                    <span className="w-2.5 h-2.5 rounded-full bg-cyan-500 mr-3"></span>
                    <Link to="#" className="text-gray-400 text-sm hover:text-gray-900 no-underline">VendorForum</Link>
                  </div>
                  <span className="text-gray-900 text-sm">{dashboardData?.totalVendorForum || 0}</span>
                </li>
                <li className="flex justify-between items-center mb-2">
                  <div className="flex items-center">
                    <span className="w-2.5 h-2.5 rounded-full bg-cyan-500 mr-3"></span>
                    <Link to="#" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Comments</Link>
                  </div>
                  <span className="text-gray-900 text-sm">{dashboardData?.totalComment || 0}</span>
                </li>
                <li className="flex justify-between items-center mb-2">
                  <div className="flex items-center">
                    <span className="w-2.5 h-2.5 rounded-full bg-cyan-500 mr-3"></span>
                    <Link to="#" className="text-gray-400 text-sm hover:text-gray-900 no-underline">Replies</Link>
                  </div>
                  <span className="text-gray-900 text-sm">{dashboardData?.totalReply || 0}</span>
                </li>
                </>
              )}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default StatsCards;
